import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import request from '@/router/axios';
export var getList = function getList(current, size, params) {
  return request({
    url: '/api/blade-system/tenant/list',
    method: 'get',
    params: _objectSpread(_objectSpread({}, params), {}, {
      current: current,
      size: size
    })
  });
};
export var getDetail = function getDetail(id) {
  return request({
    url: '/api/blade-system/tenant/detail',
    method: 'get',
    params: {
      id: id
    }
  });
};
export var remove = function remove(ids) {
  return request({
    url: '/api/blade-system/tenant/remove',
    method: 'post',
    params: {
      ids: ids
    }
  });
};
export var add = function add(row) {
  return request({
    url: '/api/blade-system/tenant/submit',
    method: 'post',
    data: row
  });
};
export var update = function update(row) {
  return request({
    url: '/api/blade-system/tenant/submit',
    method: 'post',
    data: row
  });
};
export var setting = function setting(ids, form) {
  return request({
    url: '/api/blade-system/tenant/setting',
    method: 'post',
    params: _objectSpread(_objectSpread({}, form), {}, {
      ids: ids
    })
  });
};
export var datasource = function datasource(tenantId, datasourceId) {
  return request({
    url: '/api/blade-system/tenant/datasource',
    method: 'post',
    params: {
      tenantId: tenantId,
      datasourceId: datasourceId
    }
  });
};
export var info = function info(domain) {
  return request({
    url: '/api/blade-system/tenant/info',
    method: 'get',
    params: {
      domain: domain
    }
  });
};